/**
 * MOCK TEMPORÁRIO - AFOSR-2276 (OSR_PDL_UPGRADE_AFOSR_2276)
 *
 * IDs fixos dos serviços mockados de "somente retirada" (PICKUP_ONLY) e
 * "somente entrega" (DELIVERY_ONLY) — quebra do serviço Leva e Traz.
 *
 * Esses IDs são usados para:
 *  - identificar os serviços injetados mockadamente em `dealer.services`
 *    (ver `DealerService#injectMockUpgradedPdlServicesIfEnabled`);
 *  - vincular os botões correspondentes em `buttonsList`
 *    (ver `PickupAndDeliveryComponent#addUpgradedPdlServiceButtons`).
 *
 * TODO: remover este arquivo e todas as referências a ele quando o back-end
 * passar a disponibilizar nativamente os serviços PICKUP_ONLY / DELIVERY_ONLY.
 */
export const MOCK_PICKUP_ONLY_SERVICE_ID = 900001;
export const MOCK_DELIVERY_ONLY_SERVICE_ID = 900002;
